<template>
    <div>
        <!-- MAIN MODAL - SHOW TOPIC WITH ANSWERS -->
        <q-modal ref="modalbody" v-if="!editing_question && !editing_answer" v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModal()">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense v-close-overlay icon="close" />
                    <q-toolbar-title>{{ $t('topic') + ': ' + topic.title }}</q-toolbar-title>
                </q-toolbar>

                <div class="row">
                    <div class="col-12">
                        <q-list>
                            <q-item dense multiline>
                            <q-item-side class="q-pa-xs" v-if="topic.avatar" :avatar="topic.avatar" />
                            <q-item-side class="q-pa-xs" v-else :avatar="getPlaceholderAvatar" />
                            <q-item-main>
                                <q-item-tile sublabel lines="2">
                                    <span class="text-light" v-if="$q.platform.is.desktop">{{ $t('added_by') + ' ' }}</span>
                                    <span class="text-italic text-bold">{{ topic.author }}</span>
                                </q-item-tile>
                            </q-item-main>
                            <q-item-side right>
                                <q-item-tile stamp>
                                    <span v-if="$q.platform.is.desktop">{{ $t('created_in') + ': '}}</span>
                                    <span>{{ topic.updated_date }}</span>
                                </q-item-tile>
                                <q-item-tile>
                                    <q-btn class="q-pa-sm" flat rounded color="negative" icon="fal fa-flag-alt" @click="report_question = true">
                                        <q-tooltip>{{ $t('report') }}</q-tooltip>
                                    </q-btn>
                                </q-item-tile>
                            </q-item-side>
                            </q-item>
                            <q-item dense multiline>
                                <q-item-main>
                                    <q-item-tile class="text-center text-bold" label lines="1">{{ topic.title }}</q-item-tile>
                                    <viewer class="reply q-pt-xs" v-if="markdown_enabled" :text="renderQuestion" />
                                    <p v-if="!markdown_enabled" class="reply q-pt-xs">{{ renderQuestion }}</p>
                                </q-item-main>
                            </q-item>
                            <q-item dense>
                                <q-item-main>
                                </q-item-main>
                                <q-item-side right>
                                    <q-item-tile class="q-mt-sm q-mb-xs q-mx-md">
                                        <q-btn v-if="id === topic.author_id && answers.length < 1" flat rounded color="negative" icon="fal fa-trash-alt" @click="delete_question = true">
                                            <q-tooltip>{{ $t('delete') }}</q-tooltip>
                                        </q-btn>
                                        <q-btn v-if="id === topic.author_id && answers.length < 1" flat rounded color="primary" icon="fal fa-pencil-alt" @click="editQuestion(topic)">
                                            <q-tooltip>{{ $t('edit') }}</q-tooltip>
                                        </q-btn>
                                        <!-- :disabled="id === topic.author_id" -->
                                        <q-btn :disabled="id === topic.author_id" flat rounded color="primary" :icon="getLikedIcon(topic)" @click="likeTopic">
                                            <q-tooltip>{{ getLikedText(topic) }}</q-tooltip>
                                        </q-btn>
                                        <span v-if="topic.likes && topic.likes > 0" class="q-mt-sm q-mb-xs q-mx-xs"> {{ topic.likes }}</span>
                                        <q-btn flat rounded color="primary" icon="fal fa-reply" @click="ScrollToAnswerBox">
                                            <q-tooltip>{{ $t('reply') }}</q-tooltip>
                                        </q-btn>
                                    </q-item-tile>
                                </q-item-side>
                            </q-item>
                        </q-list>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12" ref="answersBody" v-if="answers && answers.length > 0">
                        <q-list v-for="(answer, index) in answers" :key="index" class="text-align-center">
                            <q-item dense multiline>
                            <q-item-side class="q-pa-xs" v-if="answer.avatar" :avatar="answer.avatar" />
                            <q-item-side class="q-pa-xs" v-else :avatar="getPlaceholderAvatar" />
                            <q-item-main>
                                <q-item-tile sublabel lines="2">
                                    <span class="text-light" v-if="$q.platform.is.desktop">{{ $t('replied_by') + ' ' }}</span>
                                    <span class="text-italic text-bold">{{ answer.author }}</span>
                                </q-item-tile>
                            </q-item-main>
                            <q-item-side right>
                                <q-item-tile stamp>
                                    <span v-if="$q.platform.is.desktop">{{ $t('replied_in') + ': '}}</span>
                                    {{ answer.updated_date }}
                                </q-item-tile>
                                <q-item-tile>
                                    <q-btn class="q-pa-sm" flat rounded color="negative" icon="fal fa-flag alt" @click="getReportAnswerFunction(answer)">
                                        <q-tooltip>{{ $t('report') }}</q-tooltip>
                                    </q-btn>
                                    <!-- <q-btn class="q-pa-sm" v-if="id !== answer.author_id && answer.report" flat rounded color="negative" icon="fas fa-flag-alt" @click="setAnswerToReport(answer)">
                                        <q-tooltip>{{ $t('answer_reported') }}</q-tooltip>
                                    </q-btn> -->
                                </q-item-tile>
                            </q-item-side>
                            </q-item>
                            <q-item dense>
                                <q-item-main>
                                    <viewer class="reply q-pt-xs" :text="answer.answer" />
                                </q-item-main>
                            </q-item>
                            <q-item dense>
                                <q-item-main>
                                </q-item-main>
                                <q-item-side right>
                                    <q-item-tile  class="q-mt-sm q-mb-xs q-mx-md">
                                        <q-btn v-if="id === answer.author_id" flat rounded color="negative" icon="fal fa-trash-alt" @click="setAnswerToDelete(answer)">
                                            <q-tooltip>{{ $t('delete') }}</q-tooltip>
                                        </q-btn>
                                        <q-btn v-if="id === answer.author_id" flat rounded color="primary" icon="fal fa-pencil-alt" @click="editAnswer(answer)">
                                            <q-tooltip>{{ $t('edit') }}</q-tooltip>
                                        </q-btn>
                                        <q-btn :disabled="id === answer.author_id" flat rounded color="primary" :icon="getLikedIcon(answer)" @click="likeAnswer(answer)">
                                            <q-tooltip>{{ getLikedText(answer) }}</q-tooltip>
                                        </q-btn>
                                        <span v-if="answer.likes && answer.likes > 0" class="q-mt-sm q-mb-xs q-mx-xs"> {{ answer.likes }}</span>
                                        <!-- <q-btn flat rounded color="primary" icon="fal fa-reply">
                                            <q-tooltip>{{ $t('reply') }}</q-tooltip>
                                        </q-btn> -->
                                    </q-item-tile>
                                </q-item-side>
                            </q-item>
                        </q-list>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12" v-if="!answers.length && topic && topic.status === 1">
                        <q-list class="text-align-center" inset-separator>
                            <q-item-main>
                                <p class="text-center q-pa-md">{{ $t('topic_without_replies') }}</p>
                            </q-item-main>
                        </q-list>
                    </div>
                </div>

                <div v-if="topic && topic.status === 1" class="row">
                    <div class="col-12">
                        <editor :initialText="editor_initial_text" :editorText="message" :imagePath="image_path" :imageUpload="image_upload" :custom_directory="custom_directory" @setMessageWithImage="setMessageWithImage" @setMessage="setMessage" :id="new_uid" />
                    </div>
                </div>

                <div v-if="topic && topic.status === 4" class="row">
                    <div class="q-my-md text-center col-12">
                        <h5 class="text-h5">{{ $t('topic_is_closed') }}</h5>
                    </div>
                </div>

                <q-toolbar slot="footer">
                    <q-btn v-show="topic && topic.status === 1" class="q-mx-sm" color="positive" :disabled="message && message.length < 3" :label="$t('send_reply')" @click="replyToTopic" />
                    <q-btn class="q-mx-sm" color="negative" :label="$t('close')" @click="hideModal()" />
                </q-toolbar>

            </q-modal-layout>
        </q-modal>

        <!-- EDIT QUESTION MODAL -->
        <q-modal v-if="editing_question" v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModal()">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense v-close-overlay icon="close" />
                    <q-toolbar-title>{{ $t('edit_topic').toUpperCase() }}</q-toolbar-title>
                </q-toolbar>

                <div class="row q-ma-md">
                    <div class="col-12">
                    <p class="q-my-md text-center">{{ $t('edit_topic') }}</p>
                        <q-input class="q-my-md" v-model="new_title" :float-label="$t('topic')" :error="$v.new_title.$error" @input="$v.new_title.$touch" />
                        <p class="q-my-md text-center">{{ $t('your_question') }}</p>
                        <editor class="q-my-md" :editorText="message" :initialText="question" :imagePath="image_path" :imageUpload="image_upload" :custom_directory="custom_directory" @setMessage="setMessage" @setMessageWithImage="setMessageWithImage" :id="new_uid" />
                    </div>
                </div>

                <q-toolbar slot="footer">
                    <q-btn class="q-mx-sm" color="positive" :label="$t('edit_topic')" :disabled="new_title.length < 4 || message.length < 4" @click="saveEditedQuestion" />
                    <q-btn class="q-mx-sm" color="negative" :label="$t('cancel')" @click="editing_question = false" />
                </q-toolbar>

            </q-modal-layout>
        </q-modal>

        <!-- EDIT ANSWER MODAL -->
        <q-modal v-if="editing_answer" v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModal()">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense v-close-overlay icon="close" />
                    <q-toolbar-title>{{ $t('edit_reply').toUpperCase() }}</q-toolbar-title>
                </q-toolbar>

                <div class="col-12">
                    <q-list>
                        <q-item multiline>
                        <q-item-side class="q-pa-xs" v-if="topic.avatar" :avatar="topic.avatar" />
                        <q-item-side class="q-pa-xs" v-else :avatar="getPlaceholderAvatar" />
                        <q-item-main>
                            <q-item-tile sublabel lines="2">
                                <span class="text-light" v-if="$q.platform.is.desktop">{{ $t('added_by') + ' ' }}</span>
                                <span class="text-italic text-bold">{{ topic.author }}</span>
                            </q-item-tile>
                        </q-item-main>
                        <q-item-side right>
                            <q-item-tile stamp>
                                <span v-if="$q.platform.is.desktop">{{ $t('created_in') + ': '}}</span>
                                <span>{{ topic.updated_date }}</span>
                            </q-item-tile>
                            <q-item-tile class="q-pa-md" icon="fal fa-flag-alt" color="negative">
                                <q-tooltip>{{ $t('report') }}</q-tooltip>
                            </q-item-tile>
                        </q-item-side>
                        </q-item>
                        <q-item multiline>
                            <q-item-main>
                                <q-item-tile class="text-center text-bold" label lines="1">{{ topic.title }}</q-item-tile>
                                <viewer class="reply q-pt-md" v-if="markdown_enabled" :text="renderQuestion" />
                                <p v-if="!markdown_enabled" class="reply q-pt-md">{{ renderQuestion }}</p>
                            </q-item-main>
                        </q-item>
                    </q-list>
                </div>

                <div class="row q-ma-md">
                    <div class="col-12">
                    <p class="q-my-md text-center">{{ $t('edit_reply') }}</p>
                        <editor class="q-my-md" :editorText="message" :initialText="previous_answer" :imagePath="image_path" :imageUpload="image_upload" :custom_directory="custom_directory" @setMessage="setMessage" @setMessageWithImage="setMessageWithImage" :id="new_uid" />
                    </div>
                </div>

                <q-toolbar slot="footer">
                    <q-btn class="q-mx-sm" color="positive" :label="$t('edit_reply')" :disabled="message.length < 4" @click="saveEditedAnswer" />
                    <q-btn class="q-mx-sm" color="negative" :label="$t('cancel')" @click="editing_answer = false" />
                </q-toolbar>

            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="delete_question">
            <span slot="title">{{ $t('delete_topic') }}</span>

            <span slot="message">{{ $t('confirm_delete_topic') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="delete_question = false" />
                <q-btn color="negative" :label="$t('delete')" @click="deleteQuestion()" />
            </template>
        </q-dialog>


        <q-dialog v-model="delete_answer">
            <span slot="title">{{ $t('delete_reply') }}</span>

            <span slot="message">{{ $t('confirm_delete_reply') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="delete_answer = false" />
                <q-btn color="negative" :label="$t('delete')" @click="deleteAnswer()" />
            </template>
        </q-dialog>

        <q-dialog v-model="report_question">
            <span slot="title">{{ $t('report_topic') }}</span>

            <span slot="message">{{ $t('confirm_report_topic') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="report_question = false" />
                <q-btn color="negative" :label="$t('report')" @click="reportQuestion" />
            </template>
        </q-dialog>

        <q-dialog v-model="report_answer">
            <span slot="title">{{ $t('report_answer') }}</span>

            <span slot="message">{{ $t('confirm_report_answer') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="report_answer = false" />
                <q-btn color="negative" :label="$t('report')" @click="reportAnswer" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { uid, scroll } from 'quasar'

const { getScrollTarget, setScrollPosition } = scroll

export default {
    props: ['topic', 'show'],

    data() {
        return {
            loading: false,
            image_upload: true,
            image_path: 'media/html_images/courses/forum',
            custom_directory: false,
            editor_initial_text: '',
            editing_question: false,
            editing_answer: false,
            report_question: false,
            report_answer: false,
            delete_question: false,
            delete_answer: false,
            answer_edit_id: null,
            answer_delete_id: null,
            answer_report_id: null,
            answers: [],
            question: '',
            message: '',
            new_title: '',
            previous_answer: '',
            new_uid: 1,
            markdown_enabled: false,
        }
    },

    components: {
        'editor': () => import('components/editor/Editor'),
        'viewer': () => import('components/editor/Viewer')
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            id: 'common/id',
        }),

        renderQuestion() {
            return this.question
        },

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_modal: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('hideModal', '')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '84vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '70vw'
        },

        getPlaceholderAvatar() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
                return client.user_avatar_placeholder
            }
			else return ''
        },
    },

    methods: {
        ScrollToAnswerBox () {
            const ele = this.$refs.answersBody // You need to get your element here
            const target = getScrollTarget(ele)
            const offset = ele.offsetTop + ele.scrollHeight
            const duration = 1000
            setScrollPosition(target, offset, duration)
        },

        setMessage(val) {
            this.message = val
        },

        setMessageWithImage(val) {
            if (this.editing_answer) {
                this.message = val
                this.previous_answer = val
            } else if (this.editing_question) {
                this.message = val
                this.question = val
            } else {
                this.message = val
                this.editor_initial_text = val
            }

            this.fetchTopic()
            setTimeout(() => {
                this.editor_initial_text = ''
            }, 100)
        },

        hideModal() {
            this.answers = []
            this.$emit('hideModal', '')
        },

        getLikedText(val) {
            if (val.liked) return this.$t('liked')
            else return this.$t('like')
        },

        getLikedIcon(val) {
            if(val.liked) return 'fas fa-thumbs-up'
            else return 'fal fa-thumbs-up'
        },

        deleteQuestion() {
            this.delete_question = false
            this.loading = true
            this.$q.loading.show()

            this.$axios.delete(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/delete_topic/`, this.getHeader)
            .then(response => {
                this.$q.notify({
                    message: this.$t('topic_deleted'),
                    type: 'positive',
                    icon: 'fal fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('error_deleting_topic'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
                console.log(e)
            })
            .finally(() => {
                this.loading = false
                this.$q.loading.hide()
                this.hideModal()
            })
        },

        reportQuestion() {
            this.report_question = false
            this.loading = true
            this.$q.loading.show()

            let empty = {}

            this.$axios.post(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/send_topic_report/`, empty, this.getHeader)
            .then(response => {
                this.$q.notify({
                    message: this.$t('topic_reported'),
                    type: 'positive',
                    icon: 'fal fa-flag-alt'
                })
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('error_reporting_topic'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
                console.log(e)
            })
            .finally(() => {
                this.loading = false
                this.$q.loading.hide()
            })
        },

        setAnswerToDelete(val) {
            this.answer_delete_id = val.answer_id
            this.delete_answer = true
        },

        deleteAnswer() {
            this.delete_answer = false
            this.loading = true
            this.$q.loading.show()

            this.$axios.delete(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/answer/${this.answer_delete_id}/`, this.getHeader)
            .then(response => {
                this.$q.notify({
                    message: this.$t('reply_deleted'),
                    type: 'positive',
                    icon: 'fal fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('error_deleting_reply'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
                console.log(e)
            })
            .finally(() => {
                this.answer_delete_id = null
                this.loading = false
                this.$q.loading.hide()
                this.hideModal()
                this.fetchTopic()
            })
        },

        getReportAnswerFunction(ans) {
            if (ans.report) return
            else this.setAnswerToReport(ans)
        },

        setAnswerToReport(val) {
            this.answer_report_id = val.answer_id
            this.report_answer = true
        },

        reportAnswer() {
            this.report_answer = false
            this.loading = true
            this.$q.loading.show()

            let empty = {}

            this.$axios.post(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/answer/${this.answer_report_id}/send_topic_answer_report/`, empty, this.getHeader)
            .then(response => {
                this.$q.notify({
                    message: this.$t('answer_reported'),
                    type: 'positive',
                    icon: 'fal fa-flag-alt'
                })
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('error_reporting_answer'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
                console.log(e)
            })
            .finally(() => {
                this.answer_report_id = null
                this.loading = false
                this.$q.loading.hide()
                this.fetchTopic()
            })
        },

        editQuestion() {
            this.editing_question = true
        },

        editAnswer(val) {
            this.editing_answer = true
            this.previous_answer = val.answer
            this.answer_edit_id = val.answer_id
        },

        saveEditedQuestion() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()
                this.loading = false

                let update = { "title": this.new_title, "question": this.message }

                this.$axios.put(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/update_topic/`, update, this.getHeader)
                .then(response => {
                    this.$q.notify({
                        message: this.$t('topic_edited'),
                        type: 'positive',
                        icon: 'fal fa-pencil-alt'
                    })
                })
                .catch(e => {
                    this.$q.notify({
                        message: this.$t('error_editing_topic'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                    console.log(e)
                })
                .finally(() => {
                    this.editing_question = false
                    this.$q.loading.hide()
                    this.loading = false
                    this.hideModal()
                    this.fetchTopic()
                })
            }
        },

        saveEditedAnswer() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()
                this.loading = true

                let update = { "answer": this.message }

                this.$axios.put(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/answer/${this.answer_edit_id}/`, update, this.getHeader)
                .then(response => {
                    this.$q.notify({
                        message: this.$t('reply_edited'),
                        type: 'positive',
                        icon: 'fal fa-pencil-alt'
                    })
                })
                .catch(e => {
                    this.$q.notify({
                        message: this.$t('error_editing_reply'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                    console.log(e)
                })
                .finally(() => {
                    this.answer_edit_id = null
                    this.editing_answer = false
                    this.$q.loading.hide()
                    this.loading = false
                    this.hideModal()
                    this.fetchTopic()
                })
            }
        },

        likeAnswer(val) {
            let answer_id = val.answer_id
            let empty = {}

            this.$axios.post(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/answer/${answer_id}/set_like/`, empty, this.getHeader)
                .then(response => {
                    this.fetchTopic()
                })
                .catch(e => {
                    console.log(e)
                    this.fetchTopic()
                })
        },

        likeTopic() {
            let empty = {}

            this.$axios.post(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/set_like_topic/`, empty, this.getHeader)
                .then(response => {
                    this.fetchTopic()
                })
                .catch(e => {
                    console.log(e)
                    this.fetchTopic()
                })
        },

        replyToTopic() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let reply = { "answer": this.message }

                this.$axios.post(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/create_answer/`, reply, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('reply_send_success'),
                        type: 'positive',
                        icon: 'fal fa-paper-plane'
                    })

                })
                .catch(e => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('reply_send_error'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                    console.log(e)
                })
                .finally((e) => {
                    this.fetchTopic()
                })
            }
        },

        fetchTopic() {
            this.loading = true
            this.$q.loading.show()

            if (this.message.length) {
                this.message = ''
                this.new_uid = uid()
            }

            this.new_title = this.topic.title

            this.$axios.get(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/${this.topic.id}/list_topic_and_answers/`, this.getHeader)
            .then(response => {
                this.question = response.data.question
                this.answers = response.data.answers

                if (this.answers.length) {
                    this.answers = this.answers.map(ans => {
                        return {
                            status: ans.status,
                            author_id: ans.author.id,
                            answer: ans.answer,
                            answer_id: ans.id,
                            liked: ans.liked,
                            likes: ans.likes,
                            report: ans.report,
                            author: ans.author.name,
                            avatar: ans.author.author_image,
                            updated_date: date.formatDate(ans.updated_date, 'DD/MM/YYYY HH:mm'),
                        }
                    })
                    // .filter(a => a.status === 1)
                }
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.markdown_enabled = true
                this.loading = false
                this.$q.loading.hide()
            })
        },
    },

    validations() {
        return {
            'new_title': {
                requiredIf: requiredIf(() => {
                    if(this.editing_question) return true
                    else return false
                })
            },
            message: { required },
        }
    },

    beforeDestroy() {
        if (this.answers.length) {
            this.answers = []
        }
        this.message = ''
        this.editor_initial_text = ''
        this.markdown_enabled = false
    },

    mounted () {
        this.new_uid = uid()
        if (this.topic) this.fetchTopic()
    },

}
</script>

<style lang="stylus" scoped>
    .reply
        font-size 100%
</style>
